export const APP_UPDATE = 'APP_UPDATE';
export const APP_STORE = 'APP_STORE';
export const APP_NAVIGATE = 'APP_NAVIGATE';

export function update(payload, merge = true, path) {
  return {
    type: APP_UPDATE,
    payload,
    path,
    merge
  };
}

export function store(payload, merge = true, path) {
  return {
    type: APP_STORE,
    payload,
    path,
    merge
  };
}

export function navigate() {
  return {
    type: APP_NAVIGATE
  };
}



// WEBPACK FOOTER //
// ./js/actions/app.js